import { Component } from '@angular/core';
import { Option, StaticStringSelectComponent } from '../static-string-select/static-string-select.component';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';

@Component({
  selector: 'automata-auxiliary-data-dropdown',
  templateUrl: '../static-string-select/static-string-select.component.html',
  imports: [
    CommonModule,
    TranslateModule,
    GalaxyAlertModule,
    MatButtonModule,
    MatCardModule,
    FormsModule,
    GalaxyFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule,
    MatSelectModule,
  ],
})
export class AuxiliaryDataDropdownComponent extends StaticStringSelectComponent {
  options: Option[];
  required: boolean;

  initialize(label: string, filterData: Option[]): void {
    this.options = filterData;
    this.label = label;
    this.required = true;
  }
}
